module.exports = __webpack_public_path__ + "media/npc_dota_hero_weaver.561fbc20.webm";